<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title"></h4>
                        <p class="category"></p>
                    </div>

                    <div class="container-fluid">
                        <div *ngIf="loading" class="loading text-center black">
                            <br />
                            <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                            <br />
                            <p>Loading, please wait...</p>
                        </div>
                        <iframe (mouseenter) ="hideLoading()" src="https://www.oneideaaway.com/coaches"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
